// extracted by mini-css-extract-plugin
module.exports = {"PowerForAll":"PowerForAll_PowerForAll__qeGJQ"};